import { Component, OnInit, OnDestroy } from '@angular/core';
import { MasterActions, GridHeader, Enquirylist, defaultEnquirylist, GridHeaderEx } from 'src/app/model';
import { Subscription } from 'rxjs';
import { MsgService, EnquirylistService,UserType,UtilService } from 'src/app/service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-enquirylist',
  templateUrl: './enquirylist.component.html',
  styleUrls: ['./enquirylist.component.scss']
})
export class EnquirylistComponent implements OnInit, OnDestroy, MasterActions {
  private subscription = new Subscription();
  public cols: Array<GridHeader> = [];
  public dataArray: Array<Enquirylist>;
  public selectedRows: Array<any> = [];
  public selectedColumns: Array<GridHeader>;
  public dataObj: Enquirylist = defaultEnquirylist;
  public isDeleteDetails = false;
  public isAddDetails = false;
  public isEditDetails = false;
  public isViewDetails = false;
  public editCallTypeList: any = {};
  public itemDataArray: Array<any> = [];
  public EnquirylistList: Array<SelectItem> = [];
  public selectedEnquirylist: Enquirylist;

  public set isEditShow(value: boolean) {
    this.isEditDetails = value;
    this.isAddDetails = value;
  }

  public get isEditShow() {
    return this.isEditDetails || this.isAddDetails;
  }
  public get isCreator() {
    return this.util.getUserRole === UserType.Creator;
  }
  public get dlgHeader() {
    return (this.isViewDetails ? 'View ' : (this.isEditDetails ? 'Edit ' : 'Add ')) + this.pageName;
  }

  /** grid columns and data fields */
  private columnsConfig: Array<GridHeaderEx> = [
    { field: 's_no', header: 'S No', isVisible: true, isDefault: true },
	  { field: 'enq_id', header: 'Id', isVisible: false, isDefault: true },
    { field: 'e_name', header: 'User Name ', isVisible: true, isDefault: true },
    { field: 'e_email_id', header: 'User Mail id', isVisible: true, isDefault: true },
    { field: 'e_phone', header: 'User Phone ', isVisible: true, isDefault: true },
    { field: 'e_message', header: 'User Message', isVisible: true, isDefault: true },
    { field: 'created_on', header: 'Created On', isVisible: true, isDefault: true },
    { field: 'status', header: 'Actions', isVisible: false, isDefault: true },
  ];


  public itemCols = [
    { field: 's_no', header: 'S No' },
    { field: 'prod_code', header: 'Product Name' },
    { field: 'created_on', header: 'Created On' }
  ];
  public get pageName() {
    return this.dataService.pageName;
  }

  constructor(
    private msgSvc: MsgService,
    public util: UtilService,
    private dataService: EnquirylistService
  ) { }

  ngOnInit() {
    this.cols = this.columnsConfig.filter(i => i.isVisible)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });

    this.selectedColumns = this.columnsConfig.filter(i => i.isVisible && i.isDefault)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });
    this.dataService.getDataRecords();
    this.subscription.add(
      this.dataService.dataList.subscribe((data) => {
        this.dataArray = [];
        if (data.length) {
          this.dataArray = data.map((e, indx) => {
            e.s_no = indx + 1;
            return e;
          });
        } else {
          this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
        }
      }));

    
      this.subscription.add(
        this.dataService.singledataList.subscribe((data) => {
          this.itemDataArray = [];
          if (data.length) {
            this.itemDataArray = data.map((e, indx) => {
              e.s_no = indx + 1;
              return e;
            });
          } else {
            this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
          }
        }));
      // this.dataService.getEnquirylist()
      // .subscribe(data => {
      //   this.EnquirylistList = data.map(ele => {
      //     return { label: ele.Enquirylist_name, value: ele };
      //   });
      // });

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public editData(event) {
    this.dataObj = Object.assign({}, event ? event : defaultEnquirylist);
    if (event == null) {
      this.isAddDetails = true;
    } else {
      this.isEditDetails = true;
	   this.bindDropDownList();
    }
  }
  private bindDropDownList() {

    if (this.dataObj.enq_id) {
      const item = this.EnquirylistList
        // tslint:disable-next-line: triple-equals
        .find(e => e.value.enq_id == this.dataObj.enq_id);
      this.selectedEnquirylist = item ? item.value : undefined;
    }
  }
  public onEnquirylistChange(event) {
    this.dataObj.enq_id = (event.value as Enquirylist).enq_id;
  }

  public updateData() {
    if (this.isAddDetails) {
      this.createDetails();
    } else {
      this.updateCallType();
    }
  }

  public createDetails() {
    this.dataService.addData(this.dataObj).subscribe((data) => {
      if (data) {
        this.dataService.getDataRecords();
      }
    }, err => {
      this.msgSvc.addErrorMsg(err);
    });
    this.isAddDetails = false;
  }

  public cancelEditDlg() {
    this.isViewDetails = false;
    this.isAddDetails = false;
    this.isEditDetails = false;
  }

  public updateCallType() {
    this.dataService.updateData(this.dataObj).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isEditDetails = false;
  }

  public deleteDetails() {
    this.dataService.deleteData(this.dataObj.enq_id).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isDeleteDetails = false;
  }

  public deleteData(obj: Enquirylist) {
    this.dataObj = obj;
    this.isDeleteDetails = true;
  }

  public viewData(obj: Enquirylist) {
    this.dataObj = obj;  
    // this.dataService.getDataRecordsbyid(this.dataObj.enq_id);
    this.isViewDetails = true;
  }

  public updateStatus(obj: Enquirylist) {
    this.dataService.updateStatus(obj);
  }
}
